const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
	["year", 365 * 24 * 60 * 60],
	["month", 30 * 24 * 60 * 60],
	["week", 7 * 24 * 60 * 60],
	["day", 24 * 60 * 60],
	["hour", 60 * 60],
	["minute", 60],
];

// Server renders an absolute date (page cache); replace it client-side with e.g. "Vor 2 Wo."
export function initRelativeTimes(root: ParentNode = document): void {
	const formatter = new Intl.RelativeTimeFormat(document.documentElement.lang || "de", {
		numeric: "always",
		style: "narrow",
	});

	root.querySelectorAll<HTMLTimeElement>("time[data-relative-time]").forEach((el) => {
		const date = new Date(el.dateTime);
		if (Number.isNaN(date.getTime())) {
			return;
		}

		const seconds = (date.getTime() - Date.now()) / 1000;
		const [unit, unitSeconds] = UNITS.find(([, s]) => Math.abs(seconds) >= s) ?? ["minute", 60];
		const text = formatter.format(Math.round(seconds / unitSeconds), unit);

		el.title = el.textContent ?? "";
		el.textContent = text.charAt(0).toUpperCase() + text.slice(1);
	});
}
